import React, { useContext, useState, useEffect } from 'react';
import './CartPage.css';
import { ShopContext } from '../../Context/ShopContext';
import ShippingForm from './ShippingForm'; 
import CartPageRight from './CartPageRight/CartPageRight';


const CartPage = () => {
    const { cartItems, all_product, removeFromCart, getTotalCartAmount } = useContext(ShopContext);
    const [shippingMethod, setShippingMethod] = useState('standard'); 
    const [shippingFee, setShippingFee] = useState(0); 
    const [selectedProduct, setSelectedProduct] = useState(null); 
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); 
    const [deleteQuantity, setDeleteQuantity] = useState(1); 
    const [productToDelete, setProductToDelete] = useState(null); 
    const [activeTab, setActiveTab] = useState('customer-info');

    const handleShippingFeeChange = (method, fee) => {
        setShippingMethod(method); 
        setShippingFee(fee); 
    };

    // Index products by _id for quicker lookup
    const allProductsMap = all_product.reduce((map, product) => {
        map[product._id] = product;
        return map;
    }, {});

    const cartItemsWithDetails = Object.entries(cartItems)
        .filter(([key, { quantity }]) => quantity > 0) 
        .map(([key, { quantity, size, color }]) => {
            const [itemId] = key.split('-'); 
            const product = allProductsMap[itemId]; 
            return product ? { ...product, quantity, selectedSize: size, selectedColor: color } : null;
        })
        .filter(Boolean);

    const subtotal = cartItemsWithDetails.reduce((total, item) => {
        const price = item.new_price || 0; 
        return total + price * item.quantity; 
    }, 0);

    const freeShipping = subtotal >= 50;

    const openProductInfo = (product) => {
        setSelectedProduct(product);
    };

    const closeProductInfo = () => {
        setSelectedProduct(null);
    };

    const openDeleteModal = (product, quantity) => {
        setProductToDelete({
            productId: product._id,
            selectedSize: product.selectedSize,
            selectedColor: product.selectedColor,
            quantity,
        });
        setDeleteQuantity(1); 
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
    };

    const handleDeleteQuantityChange = (e) => {
        const value = e.target.value;
        if (productToDelete) {
            const maxQuantity = productToDelete.quantity || 1; 
            if (value >= 1 && value <= maxQuantity) {
                setDeleteQuantity(Number(value)); 
            }
        }
    };

    const handleDelete = () => {
        if (productToDelete && deleteQuantity > 0) {
            removeFromCart(productToDelete.productId, productToDelete.selectedSize, productToDelete.selectedColor, deleteQuantity);
            closeDeleteModal();
        }
    };

    useEffect(() => {
        const totalAmount = getTotalCartAmount();
        console.log('Total Cart Amount:', totalAmount); 
    }, [cartItems, all_product, getTotalCartAmount]); 

    return (
        <div className={`cart-page ${activeTab === 'invoice-info' ? 'invoice-info-active' : ''}`}>
        <div className={`cart-page-left ${activeTab === 'invoice-info' ? 'invoice-info-active' : ''}`}>
            <ShippingForm
                setShippingMethod={setShippingMethod} 
                setShippingFee={setShippingFee} 
                shippingMethod={shippingMethod} 
                shippingFee={shippingFee} 
                onShippingFeeChange={handleShippingFeeChange} 
                activeTab={activeTab}
                setActiveTab={setActiveTab}
            />
        </div>


            <CartPageRight
                cartItemsWithDetails={cartItemsWithDetails}
                subtotal={subtotal}
                shippingFee={shippingFee}
                openProductInfo={openProductInfo}
                openDeleteModal={openDeleteModal}
                selectedProduct={selectedProduct}
                isDeleteModalOpen={isDeleteModalOpen}
                productToDelete={productToDelete}
                deleteQuantity={deleteQuantity}
                handleDeleteQuantityChange={handleDeleteQuantityChange}
                handleDelete={handleDelete}
                closeDeleteModal={closeDeleteModal}
            />
        
        </div>
    );
};

export default CartPage;
